import createLucideIcon from '../createLucideIcon';

const FilterX = createLucideIcon('FilterX', [
  ['path', { d: 'M13.013 3H2l8 9.46V19l4 2v-8.54l.9-1.055', key: '1fi1da' }],
  ['path', { d: 'm22 3-5 5', key: '12jva0' }],
  ['path', { d: 'm17 3 5 5', key: 'k36vhe' }],
]);

export default FilterX;
